import { ref, watch, type MaybeRef } from 'vue'

export function useIsMessageHighlighted(isTarget: MaybeRef<boolean>, navnonve: MaybeRef<any>) {
  const isHighlighted = ref(false)

  let highlightTimeoutId: number | null = null

  watch(
    [isTarget, navnonve],
    ([isTarget]) => {
      if (highlightTimeoutId !== null) {
        clearTimeout(highlightTimeoutId)
        highlightTimeoutId = null
      }

      if (!isTarget) {
        isHighlighted.value = false
        return
      }

      isHighlighted.value = true
      setTimeout(() => {
        isHighlighted.value = false
        highlightTimeoutId = null
      }, 2000)
    },
    { immediate: true }
  )

  return isHighlighted
}
